import React from "react";
import { Autoplay, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Typography, useMediaQuery, useTheme } from "@mui/material";

function SwiperImages({ data, section = "details", slides = 1 }) {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));
  // const isLargeScreen = useMediaQuery(theme.breakpoints.only("lg"));
  // const isXLargeScreen = useMediaQuery(theme.breakpoints.only("xl"));
  if (data.length === 0) {
    return (
      <Typography
        component="span"
        textAlign="center"
        variant="h6"
        mt={3}
        color="GrayText"
      >
        Sin Imágenes
      </Typography>
    );
  }

  return (
    <Swiper
      effect="cards"
      slidesPerView={slides}
      slidesPerGroup={1}
      loopAdditionalSlides={10}
      spaceBetween={0}
      loop={slides < 1 && data.length <= slides}
      navigation={true}
      pagination={true}
      autoplay={{
        delay: 3500,
        disableOnInteraction: false,
      }}
      modules={[Navigation, Pagination, Scrollbar, Autoplay]}
      style={{
        width: "100%",
        textAlign: "center",
      }}
    >
      {(data || []).map((image, index) => {
        return (
          <SwiperSlide key={index}>
            <img
              src={image.url}
              alt={image.name}
              style={{
                width: "100%",
                height:
                  section === "property"
                    ? isXsScreen
                      ? "300px"
                      : "350px"
                    : isXsScreen
                    ? "250px"
                    : "250px",
                objectFit: "cover",
                borderRadius: 3,
              }}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default SwiperImages;
